import { render } from "./BasePanel.vue?vue&type=template&id=14bbc1be&scoped=true&ts=true"
import script from "./BasePanel.vue?vue&type=script&lang=ts"
export * from "./BasePanel.vue?vue&type=script&lang=ts"

import "./BasePanel.vue?vue&type=style&index=0&id=14bbc1be&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14bbc1be"]])

export default __exports__